import {
  Box,
  Button,
  List,
  Paper,
  Typography,
  Menu,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Chip,
} from "@mui/material";
import React from "react";
import { formatAsMoney } from "../../src/utils/services";
import CustomListItem from "../partials/CustomListItem";
import moment from "moment";
import { useAuthProvider } from "../../context/AuthProvider";
import { onGetDonations, onGetDonorHistory } from "../../src/utils/queries";
const DonorSideInfo = ({ clickedRow, detailed, handleRefund }) => {
  const { user } = useAuthProvider();



  const { data, isError, isLoading, isSuccess } = onGetDonorHistory(`${clickedRow.original.id}`)


  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getPlate = () => {
    if (
      !clickedRow?.original?.donor?.first_name &&
      !clickedRow?.original?.donor?.last_name
    ) {
      return `${clickedRow?.original?.channel} - ${moment(
        clickedRow?.original?.created_at
      ).format("HH:mm:ss")}`;
    }
    return `${clickedRow.original.donor?.first_name} ${clickedRow.original.donor?.last_name}`;
  };

  return (
    <>
      <Paper
        sx={{
          p: "1.5em",
          mb: "1.5em",
          boxShadow: "inset 0px -1px 0px #E4E7EB",
        }}
      >
        <Typography variant="small">{clickedRow?.original?.first_name}</Typography>
        <Typography variant="h4">
          {clickedRow?.original?.donor_code}
        </Typography>
      </Paper>
      <List sx={{ px: "1.5em" }}>
        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "grey.border40",
          }}
        >
          <CustomListItem
            big
            rightText={formatAsMoney(clickedRow.original.donations[0]?.total_donation_amount || 0)}
            leftText="Total Amount Donated"
          />
        </Box>

        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "grey.border40",
          }}
        >
          <CustomListItem
            big
            rightText={clickedRow.original.donations[0]?.number_of_donations
              || 0}
            leftText="Number of Donations"
          />
        </Box>
        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "grey.border40",
          }}
        >
          <CustomListItem
            big
            rightText={formatAsMoney(clickedRow.original.donations[0]?.total_donation_amount / clickedRow.original.donations[0]?.number_of_donations || 0)}
            leftText="Average Amount Donated"
          />
        </Box>

        {/* <CustomListItem
            rightText={
              clickedRow.values["donation_details[0].donation_type.type"]
            }
            leftText="Donation Type"
          /> */}

        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "grey.border40",
          }}
        >
          <CustomListItem
            rightText={`${clickedRow.original?.postal_code} - ${clickedRow.original?.address_line_1}, ${clickedRow.original?.city}, ${clickedRow.original?.country?.country_code}`}
            leftText="Address"
          />
        </Box>

        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "grey.border40",
          }}
        >
          <CustomListItem
            rightText={clickedRow?.original?.user?.email}
            leftText="Email"
          />
        </Box>
        <Box
          sx={{
            borderBottom: "1px solid",
            borderBottomColor: "grey.border40",
          }}
        >
          <CustomListItem
            rightText={clickedRow?.original?.phone_number}
            leftText="Phone"
          />
        </Box>

      </List>
      {/* <List sx={{ marginTop: "50px", px: "1.5em" }}>
        <Typography variant="h4" sx={{ px: '1rem', mb: '1.5rem' }}>
          Recent Donations
        </Typography>
        {!isLoading ?
          data?.data?.data?.map((item) => (
            <Box
              sx={{
                borderBottom: "1px solid",
                borderBottomColor: "grey.border40",
              }}
            >
              <Typography variant="small" sx={{ px: '1rem' }}>Donation code</Typography>
              <CustomListItem
                rightText={formatAsMoney(item?.amount_after_refund)}
                leftText={item?.donation_code
                }
              />
            </Box>
          )) : <Box display={'flex'} justifyContent='center' alignItems={'center'} my={'1em'}>
            <span className="dot-falling"></span>
          </Box>}

      </List> */}
      <List
        sx={{
          mt: '50px',
          px: '1.5em',
          maxHeight: '400px', 
          overflowY: 'auto', 
          pr: '0.5em',
          '&::-webkit-scrollbar': { width: '8px' },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,0.3)',
            borderRadius: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'rgba(0,0,0,0.1)',
          },
        }}
      >
        <Typography variant="h4" sx={{ px: '1rem', mb: '1.5rem' }}>
          Recent Donations
        </Typography>

        {!isLoading ? (
          data?.data?.data?.map((item) => (
            <Box
              key={item?.id}
              sx={{
                borderBottom: '1px solid',
                borderBottomColor: 'grey.border40',
                pb: '0.75em',
              }}
            >
              <Typography variant="small" sx={{ px: '1rem' }}>
                Donation code
              </Typography>
              <CustomListItem
                rightText={formatAsMoney(item?.amount_after_refund)}
                leftText={item?.donation_code}
              />
            </Box>
          ))
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" my="1em">
            <span className="dot-falling"></span>
          </Box>
        )}
      </List>


    </>
  );
};

export default DonorSideInfo;
